import { render } from "./BaseGrid.vue?vue&type=template&id=5c36f138"
import script from "./BaseGrid.vue?vue&type=script&lang=js"
export * from "./BaseGrid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__